import React, { useContext, useEffect } from "react";
import AccreditationButton from "../../AccreditationButton/AccreditationButton";
import { icons } from "../../../constants";
import { TranslationsContext } from "../../../utils/TranslationsContext";

const MessageModal = ({ message, onCloseClick, onClick }) => {
  const { t, isLoading } = useContext(TranslationsContext);

  useEffect(() => {
    // Handle Enter key to trigger primary action
    const handleEnterKey = (event) => {
      if (
        event.key === "Enter" &&
        !event.shiftKey &&
        !event.ctrlKey &&
        !event.metaKey
      ) {
        // Don't trigger if user is typing in a textarea or input
        const target = event.target;
        if (
          target.tagName === "TEXTAREA" ||
          (target.tagName === "INPUT" && target.type !== "submit")
        ) {
          return;
        }
        event.preventDefault();
        onClick();
        onCloseClick();
      }
    };

    document.addEventListener("keydown", handleEnterKey);

    return () => {
      document.removeEventListener("keydown", handleEnterKey);
    };
  }, [onClick, onCloseClick]);

  const handleOverlayClick = (e) => {
    // Only close if clicking directly on the overlay, not on modal content
    if (e.target === e.currentTarget) {
      onCloseClick();
    }
  };

  return (
    <div
      className="flex-direction-column items-center justify-center message-modal-wrapper"
      onClick={handleOverlayClick}
    >
      <div className="flex-direction-column gap-48 message-modal">
        <div className="flex-direction-row justify-end width-100">
          <img
            className="pointer"
            src={icons.close_gray}
            onClick={onCloseClick}
            alt="X"
          />
        </div>
        <div
          className="flex-direction-column gap-24 items-center justify-between"
          style={{ flex: 1 }}
        >
          <p className="inria-sans-400 font-24" style={{ textAlign: "center" }}>
            {t("SIMILAR_EVENT")} {` "${message}" `} {t("STILL_WANT")}
          </p>
          <AccreditationButton
            type="save"
            title={"Dodaj"}
            className="modal-save-btn"
            onClick={() => {
              onClick();
              onCloseClick();
            }}
            classNameWrapper="width-100"
          />
        </div>
      </div>
    </div>
  );
};

export default MessageModal;
